import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateHoverRange } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";

export const useResourceRequest = ({dropDownOption, onClose}) => {

    const {showSuccess, showInfo, showError} = useContext(ToastContext);
    const [popupFilters, setPopupFilters] = useState({ project: null, technology: null, resource_count: 1, experience: 0, hoveredRange: [], type: "permanent" });
    const [loader, setLoader] = useState(false);
    const [experienceOpts] = useState(Array.from({ length: 7 }, (v, i) => i));
    const [totalOpenUsers, setTotalOpenUsers] = useState(0);

    useEffect(() => {
        let sum = 0;
        _.pluck(_.filter(dropDownOption?.technologies, "user_count"), "user_count")?.forEach((item) => {
            sum += item;
        })
        setTotalOpenUsers(sum);
    }, [dropDownOption?.technologies])

    const handleCreateRequest = async () => {
        try {
            if(!popupFilters?.project) {
                showInfo("Info", "Please select project");
                return;
            } else if(!popupFilters?.technology) {
                showInfo("Info", "Please select technology");
                return;
            } else if(popupFilters?.resource_count <= 0) {
                showInfo("Info", "Number of resource required should be greater than 0");
                return;
            } else if(popupFilters?.type === "temp" && (!popupFilters?.hoveredRange?.[0] || !popupFilters?.hoveredRange?.[1])) {
                showInfo("Info", "Please select date range");
                return;
            }
            setLoader(true);
            const payload = {
                resource_request_id: 0,
                project_id: popupFilters?.project?.project_id,
                technology_name: popupFilters?.technology?.technology_name,
                total_require_resource: parseInt(popupFilters?.resource_count),
                resource_experience_year: parseInt(popupFilters?.experience),
                from_date: dateHoverRange(popupFilters?.hoveredRange[0]) || "",
                to_date: dateHoverRange(popupFilters?.hoveredRange[1]) || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTRESOURCEREQUEST"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setLoader(false);
                onClose();
            } else {
                showError("Success", res?.body?.message);
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
            setLoader(false);
        }
    }

    const handleTechnologySelected = (tech_name) => {
        const tech = _.findWhere(dropDownOption?.technologies, {technology_name: tech_name});
        setPopupFilters((prev) => ({...prev, technology: tech}));
    }

    return useMemo(() => ({
        popupFilters, setPopupFilters, handleCreateRequest, loader, handleTechnologySelected, experienceOpts, totalOpenUsers
    }), [popupFilters, setPopupFilters, handleCreateRequest, loader, handleTechnologySelected, experienceOpts, totalOpenUsers])
}